import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppLayout from './layouts';
import TestRunsPage from './pages/TestRunsPage';
import SettingsPage from './pages/SettingsPage';
import TestCasesPage from './pages/TestCasesPage';
import TestCaseGroupsPage from './pages/TestCaseGroupsPage';
import RunDetailPage from './pages/RunDetailPage';
import BugTicketsPage from './pages/BugTicketsPage';
import AnalysisAiPage from './modules/analysis/AnalysisAiPage';
import AnalysisInsightsPage from './modules/analysis/AnalysisInsightsPage';
import AnalysisTrendsPage from './modules/analysis/AnalysisTrendsPage';
import AnalysisImpactPage from './modules/analysis/AnalysisImpactPage';
import AnalysisMetricsPage from './modules/analysis/AnalysisMetricsPage';
import CompareRunsPage from './pages/CompareRunsPage';
import GroupHistoryPage from './pages/GroupHistoryPage';
import MetricsPage from './pages/MetricsPage';
import ProfilePage from './pages/ProfilePage';
import ComparePage from './modules/compare/ComparePage';

function App() {
  return (
      <BrowserRouter>
        <AppLayout>
          <Routes>
            <Route path="/" element={<MetricsPage />} />
            <Route path="/metrics" element={<MetricsPage />} />
            <Route path="/test-runs" element={<TestRunsPage />} />
            <Route path="/test-runs/:runId" element={<RunDetailPage />} />
            <Route path="/test-case-groups" element={<TestCaseGroupsPage />} />
            <Route path="/test-cases/:group" element={<TestCasesPage />} />
            <Route path="/test-groups/:group/history" element={<GroupHistoryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            {/* Legacy routes keep for backward compatibility */}
            <Route path="/root-causes" element={<BugTicketsPage />} />
            <Route path="/analysis/root-causes" element={<BugTicketsPage />} />
            {/* New Analysis section routes */}
            <Route path="/analysis/tickets" element={<BugTicketsPage />} />
            <Route path="/analysis/ai" element={<AnalysisAiPage />} />
            <Route path="/analysis/insights" element={<AnalysisInsightsPage />} />
            <Route path="/analysis/trends" element={<AnalysisTrendsPage />} />
            <Route path="/analysis/impact" element={<AnalysisImpactPage />} />
            <Route path="/analysis/metrics" element={<AnalysisMetricsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/compare-legacy" element={<CompareRunsPage />} />
          </Routes>
        </AppLayout>
      </BrowserRouter>
  );
}

export default App;
